import { GetChartAccountsTypesEnum } from "./api/openapi"

export const DEFAULT_ROWS_PER_PAGE = 15
export const DEFAULT_ROWS_PER_PAGE_OPTIONS = [5, 10, 15, 20, 30, 50, 200]
export const CHART_ACCOUNT_TYPES: GetChartAccountsTypesEnum[] = ["asset", "liability", "income", "expense", "equity"]

export const DEFAULT_MAX_AUTOCOMPLETION_RESULTS = 10

export const FIAT_DECIMAL_PLACES = 4
